import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../../components/Breadcrumb";
import { SOCIETY_MANAGEMENT, SOCIETY_MANAGEMENT_SETTINGS } from "../../../Routing/routes";
import SocietySettingsLayer from "./Component/SocietySettingsLayer";

const SettingSocietyMangement = () => {
    const { id } = useParams();
    const links = [{ to: SOCIETY_MANAGEMENT, text: 'Society Management' }, { to: SOCIETY_MANAGEMENT_SETTINGS.replace(':id', id), text: 'Society Management Settings' }]
    const societyName = "Society Name";

    return (
        <>
            <Breadcrumb description='View and Manage Community Settings' links={links} headingTitle="Community Management Settings" />
            <SocietySettingsLayer societyName={societyName} societyId={id} />
        </>
    );
};

export default SettingSocietyMangement;
